<template>
  <div>
    <HeroSection theme="blue-gradient">
      <h1 class="display-12 text-white font-size-md-down-5 font-weight-semi-bold">
        Compare <span class="text-warning">Remortgage</span> Deals
      </h1>
      <h2 class="display-12 text-white font-size-md-down-5 font-weight-semi-bold">
      </h2>
      <p v-if="usingDefault" class="text-white">
        Remortgaging is where you take out a new mortgage with a new lender on a property you already own and have a mortgage on. The new mortgage takes the place of the mortgage you originally had on the property.
      </p>
      <ProductQuerySummary v-if="!usingDefault" :query="searchQuery" @clicked="wizarding = true" :is-example="usingDefault"/>
    </HeroSection>
    <IntroductionToRemortgage v-if="usingDefault" 
                              class="space-top-1 space-bottom-0" 
                              size="sm" 
                              theme="remortgage/introduction" 
                              hide-title 
                              :custom-cta="usingDefault" 
                              custom-cta-text="Let's get started..." 
                              @clicked="wizarding = true"/>
    <div class="space-bottom-2" :class="{ 'space-top-0': usingDefault, 'space-top-1': !usingDefault }">
      <div v-if="showProducts" class="">
        <div class="">
          <ProductExplorer 
              v-if="searchQuery != null" 
              :query="searchQuery" 
              :filters="null" 
              :disable-search-modal="false" 
              hide-filters
              @data-available="displayBestBuys($event)"
              @retry="openWizard()" :only-best-buys="usingDefault" :is-example="usingDefault" />
        </div>
      </div>
      <ProductQuickSearchModal :query="searchQuery" 
                               :show="wizarding" 
                               @closed="wizarding = false" @saved="wizardCompleted($event)"/>
    </div>
  </div>
</template>

<script>
  import HeroSection from "@/components/layout/HeroSection";
  import ProductExplorer from "@/components/ProductExplorer";
  import ProductCardPlaceholder from "@/components/products/ProductCardPlaceholder";
  import {mapGetters, mapActions } from "vuex";
  import MortgageWizard from "@/components/MortgageWizard";
  import GettingStartedBanner from "@/components/mortgage-watch/GettingStartedBanner"
  import {ProductSearchQuery} from "@/utils/ProductSearchQuery";
  import {MortgageWatchQuery} from "@/utils/MortgageWatchQuery.ts";
  import ProductQuerySummary from "@/components/products/ProductQuerySummary";
  import ProductQuickSearchModal from "@/components/products/ProductQuickSearchModal";
  import IntroductionToRemortgage from "@/components/home/IntroductionToRemortgage";
  
  export default {
    name: "Remortgage",
    
    data() {
      return {
        wizarding: false,
        editMode: false,
        usingDefault: true,
        searchQuery: ProductSearchQuery.newRemortgage(315000, 175000, 25),
        bestBuyData: null
      }
    },
    
    components: {
      IntroductionToRemortgage,
      ProductQuickSearchModal,
      ProductQuerySummary,
      HeroSection,
      ProductExplorer,
    },
    
    computed: {
      ...mapGetters([
        "allLenders",
        "watchers", "userWatchers", "mostRecentWatcher", "getWatcher",
        "currentUser", "isLoggedIn"
      ]),
      
      showProducts() {
        return this.searchQuery != null;
      }
    },

    methods: {
      ...mapActions([
         "addWatcher", "saveUserWatcher"
      ]),
      
      openWizard() {
        this.wizarding = true;
      },
      
      wizardClosed() {
        this.wizarding = false;
      },
      
      async wizardCompleted(event) {
        this.wizarding = false;
        this.usingDefault = false;
        this.searchQuery = new ProductSearchQuery(event);
      },
      
      displayBestBuys(data) {
        this.bestBuyData = data;
      }
    }
  }
</script>
